import angular from 'angular';

class Messages {
  constructor($log, $http, $rootScope, ngDialog, Endpoints, Utils, Users, Auth, $state) {
    'ngInject';

    Object.assign(this, {
      $log,
      $http,
      $rootScope,
      ngDialog,
      Endpoints,
      Utils,
      Users,
      Auth,
      $state,
    });
  }
  /**
   * Get all unread messages
   * @returns {Array} Unread messages
   */

  getAll() {
    return this.$http.get(this.Endpoints.messages.pool, {
      loadingText: 'Loading Messages',
    });
  }

  getAllUnreadMessages(cursor, messageState) {
    const query = Object.assign({}, messageState);

    if (query.category_id < 0) {
      delete query.category_id;
    }

    if (query.state.length !== 0) {
      query.state = query.state.map(s => (typeof s === 'object' ? s.code : s)).join('|');
    } else {
      delete query.state;
    }

    if (cursor.before) query.before = cursor.before;
    if (cursor.after) query.after = cursor.after;
    const qp = this.Utils.serializeQuery(query);
    return this.$http.get(this.Endpoints.messages.unreadPool + qp, {
      loadingText: 'Loading Messages',
    });
  }

  getPaginatedMessages(pagination, polling = false) {
    const query = { ...pagination };
    if (polling) {
      query.polling = true;
    }
    if (query.state.length !== 0) {
      query.state = query.state.map(s => (typeof s === 'object' ? s.code : s)).join('|');
    } else {
      delete query.state;
    }
    const queryString = this.Utils.serializeQuery(query);
    return this.$http.get(this.Endpoints.messages.unreadPool + queryString, {
      loadingText: 'Loading Messages',
    });
  }
  /**
   * Retrieve a message thread
   * @param {Number} user_id user id
   * @param {Object} cursor before or after cursor for pagination
   * @returns {Promise} Thread of messages
   */
  // getThread(user_id, cursor) {
  //   const qp = this.Utils.serializeQuery(Object.assign({}, cursor, { user_id }));
  //   return this.$http.get(this.Endpoints.messages.base + qp);
  // }

  getThread(user_id, cursor) {
    const qp = this.Utils.serializeQuery(Object.assign({}, cursor));
    return this.$http.get(this.Endpoints.messages.base.replace(':id', user_id) + qp);
  }
  /**
   * Specifies that a thread has been read by a physician
   * @param {number} user_id - user to send message to
   * @param {number} message_id - mark thread as read only up to this message
   * @returns {Promise} nothing
   */

  markThreadAsRead(user_id, message_id) {
    return this.$http.put(this.Endpoints.messages.markThread, {
      user_id,
      message_id,
    });
  }
  /**
   * Sends a message to a specificed user_id
   * @param {number} to_id - user to send message to
   * @param {string} content - message content
   * @returns {Promise} asf
   */

  sendMessage(to_id, content, entry_type) {
    return this.$http.post(this.Endpoints.messages.send, {
      to_id,
      content,
      entry_type,
    });
  }

  sendTextMessage(to_id, content, entry_type, mobile_no) {
    return this.$http.post(this.Endpoints.messages.send, {
      to_id,
      content,
      entry_type,
      mobile_no,
    });
  }

  messageCategoryUpdate(message_id, category_id) {
    return this.$http.put(this.Endpoints.messages.update.replace(':id', message_id), {
      category_id,
    });
  }

  messageReadUpdate(message_id, read_at) {
    return this.$http.put(this.Endpoints.messages.update.replace(':id', message_id), {
      read_at,
    });
  }

  getMessagesLock(patientId) {
    return this.$http.get(this.Endpoints.messages.locking.replace(':id', patientId));
  }

  setMessagesLock(patientId) {
    return this.$http.post(this.Endpoints.messages.locking.replace(':id', patientId));
  }

  callUnlockingModal(staffDetails, patientDetails, callback) {
    return this.ngDialog.open({
      templateUrl: 'app/components/unlocking-chat-modal/unlocking-chat-modal.html',
      controller: 'UnlockingChatModalController',
      controllerAs: 'unlockChat',
      data: {
        staffDetails,
        patientDetails,
      },

      preCloseCallback(res) {
        if (res === true) {
          return callback(true);
        }

        return callback(false);
      },
    });
  }

  openChat(patient) {
    const deregister = this.$rootScope.$on('dialog:navigate', (event, navData) => {
      this.ngDialog.close();
      this.$state.go(navData.state, navData.params);
      deregister(); // Clean up listener
    });
    var this2 = this;
    this.ngDialog.open({
      templateUrl: 'app/components/chat/chat.html',
      // To not allow the user closes the modal without explicitely to have some action
      // select the X to close
      closeByEscape: false,
      closeByNavigation: false,
      closeByDocument: false,
      // To make possible doctor still be able to use the screen behind
      overlay: false,
      controller: 'ChatController',
      controllerAs: 'chat',
      className: 'ngdialog-theme-default chat-modal',
      data: {
        patient,
      },

      preCloseCallback(res) {
        // THIS IS TO REFRESH PIMS "new message icon" IN THE VISIT DETAILS
        // AFTER CLOSING CHAT BOX

        deregister(); // Clean up listener
        this2.$rootScope.$broadcast('chat-popup:closed');
        console.log('chat-popup:closed');
        return true;
      },
    });
  }

  openText(patient) {
    this.ngDialog.open({
      templateUrl: 'app/components/text-message/sms.html',
      // To not allow the user closes the modal without explicitely to have some action
      // select the X to close
      closeByEscape: false,
      closeByNavigation: false,
      closeByDocument: false,
      // To make possible doctor still be able to use the screen behind
      // overlay: false,
      controller: 'SmsController',
      controllerAs: 'sms',
      className: 'ngdialog-theme-default chat-modal',
      data: {
        patient,
      },
    });
  }

  visitNotes(data) {
    this.ngDialog.open({
      templateUrl: 'app/components/visit-notes/visit-notes.html',
      // To not allow the user closes the modal without explicitely to have some action
      // select the X to close
      closeByEscape: false,
      closeByNavigation: false,
      closeByDocument: false,
      // To make possible doctor still be able to use the screen behind
      overlay: false,
      controller: 'VisitNotesController',
      controllerAs: '$ctrl',
      className: 'ngdialog-theme-default chat-modal',
      data: {
        patient: data.patient,
        visit: data.visit,
      },
    });
  }

  getCategories() {
    return this.$http.get(this.Endpoints.messages.categories);
  }
}

Messages.$inject = ['$log', '$http', '$rootScope', 'ngDialog', 'Endpoints', 'Utils', 'Users', 'Auth', '$state'];
angular.module('pims').service('Messages', Messages);
